<template>
    <!-- 培训机构列表 -->
    <div>
        <top :keyword="''" :tab="'school'"></top>
        <ul class="cdetail">
            <li>
                <div class="title">{{articles.title}}</div>
                <div class="summary">
                    <span>
                        <i class="el-icon-time" />
                        {{formatDate(articles.updateDate)}}
                    </span>
                    <span>
                        <i class="el-icon-view" />
                        {{articles.viewCount}}
                    </span>
                    <span v-if='articles.sourceFrom'>
                        <i class="el-icon-link" />
                        来源：{{articles.sourceFrom}}
                    </span>
                </div>
                <div class="line"></div>
                <div class="content" v-html="articles.content"></div>
            </li>
        </ul>
        <bottom></bottom>
    </div>
</template>
<script>
import top from './top'
import bottom from './bottom'

export default {
    name: 'ClassDetail',
    data() {
        return {
            articles: {}
        }
    },
    computed: {},
    created() {
        this.getdata()
    },
    methods: {
        getdata() {
            let id = this.$route.params.id
            this.$http
                .get(this.$cmsPath + '/article/api/' + id)
                .then(res => {
                    if (res.status == 200) {
                        this.articles = res.body.data
                        this.$http.get(this.articles.content).then(res => {
                            if (res.status == 200) {
                                this.articles.content = res.bodyText
                            }
                        })
                    }
                })
                .catch(err => {})
        },
        formatDate: function(date) {
            date = new Date(date)
            let year = date.getFullYear()
            let month = date.getMonth() + 1
            let day = date.getDate()
            if (month < 10) {
                month = '0' + month
            }
            if (day < 10) {
                day = '0' + day
            }
            return year + '-' + month + '-' + day
        }
    },
    beforeMount() {},
    watch: {},
    components: {
        bottom: bottom,
        top: top
    }
}
</script>
<style scoped>
@import '../assets/css/iconfont.css';
@import '../assets/css/common.css';
@import '../assets/css/index.css';
@import '../assets/css/cms.css';
.cdetail {
    width: 1184px;
    height: auto;
    /* background: #eee; */
    margin: 20px auto;
}
.cdetail li {
    height: auto;
    width: 100%;
    padding-top: 20px;
    list-style: none;
}
.title {
    text-align: center;
    font-size: 24px;
}
.summary {
    margin-top: 20px;
}
.summary span:nth-child(2),.summary span:nth-child(3) {
    margin-left: 20px;
}
.line {
    width: 100%;
    height: 2px;
    margin-top: 20px;
    background: #eee;
}
.content {
    text-align: left;
    font-size: 18px;
    text-indent: 40px;
}
</style>



// WEBPACK FOOTER //
// src/views/PolicyDetail.vue